export default __webpack_public_path__ + "static/media/logo.45bf73d0.svg";